import { useEffect, useState } from "react"
import CircularProgress from '@mui/material/CircularProgress';

import { DB, Constant } from "../../constants";
import SummaryReport from "../SummaryReport"
import { DynamicFormTemplate } from "../../utilities"
import { useTranslation } from 'react-i18next';

const ReportForm = (props) => {
    const { t: translate } = useTranslation();
    const {
        isHidden,
        formData
    } = props

    const email = {
        "validation-mail": process.env.REACT_APP_ENVIRONMENT === "Production",
        "validation-mail-controleur": true,
        "validation-mail-exploitant": process.env.REACT_APP_ENVIRONMENT === "Production",
    }
    const emailFormLabel = {
        "validation-mail": "Autre destinataire",
        "validation-mail-controleur": "Moi",
        "validation-mail-exploitant": "Exploitant matériel",
    }
    const emailFormOrder = {
        "validation-mail": 3,
        "validation-mail-controleur": 1,
        "validation-mail-exploitant": 2,
    }
    const submit = {
        "date-controle": true
    }

    const [emailForm, setEmailForm] = useState([])
    const [submitForm, setSubmitForm] = useState([])
    const [state, setState] = useState({})
    const [isShowSummary, setIsShowSummary] = useState(false)
    const [data, setData] = useState({})
    const [errorInput, setErrorInput] = useState([])
    const [submitBtnClicked, setSubmitBtnClicked] = useState(false)

    const seperateForm = async () => {
        const emailTemp = []
        const submitTemp = []

        for (let form of formData) {
            if (email[form.name]) {
                form.label = emailFormLabel[form.name]
                form.liste_valeurs = await mapUserListValue(form["valeur_defaut"])
                form.position = emailFormOrder[form.name]
                if(form.name === "validation-mail"){
                    form.isEmailCommaSeperated = true
                }
                emailTemp.push(form)
            }
            else if (submit[form.name]) {
                submitTemp.push(form)
            }
        }

        emailTemp.sort((a, b) => a.position - b.position)
        setEmailForm(emailTemp)
        setSubmitForm(submitTemp)
    }

    const mapUserListValue = async (value) => {
        switch (value) {
            case "emailcontroleur":
                const userEmail = await getUserEmail()
                return userEmail
            case "emailexploitant":
                const mailInput = document.getElementById("exploitant-mail")
                if(!mailInput){
                    return ""
                }
                return mailInput.value
            default:
                return ""
        }
    }

    const getUserEmail = async () => {
        const usersDataQuery = await DB.users.toArray();
        const checkExistingUser = usersDataQuery.filter((user) => user.data.personnel_controleur && user.data.personnel_controleur.id === localStorage.getItem(Constant.localStorageKey.userId));
        if (checkExistingUser.length > 0) {
            return checkExistingUser[0].data.personnel_controleur.email
        }
        return ""
    }

    const generateConstantValue = () => {
        const year = new Date().getFullYear()
        const month = new Date().getMonth() + 1
        const date = new Date().getDate()
        setState({
            "date_controle": `${date.toString().length === 1 ? '0' + date : date}/${month.toString().length === 1 ? '0' + month : month}/${year}`
        })
    }

    const renderResult = () => {
        const rows = []
        submitForm.forEach(form => {
            const propertyName = form.name.split("-").join("_")
            rows.push(<div key={form.name} className="form-group form-element">
                <p htmlFor={form.name}>{form.label} {form.requis ? <span className='text-danger'>*</span> : null}</p>
                <p className="bold">{state[propertyName]}</p>
            </div>)
        })

        return rows
    }

    const showSummary = () => {
        window.dispatchEvent(new Event(Constant.event.showSummary))
    }

    const closeSummary = () => {
        window.dispatchEvent(new Event(Constant.event.closeSummary))
    }

    const close = () => {
        setIsShowSummary(false)
    }

    const setReportData = (e) => {
        setData(e.detail.data)
        setErrorInput(e.detail.error)
        setIsShowSummary(true)
    }

    const handleSubmitBtnClick = () => {
        setSubmitBtnClicked(true)
    }

    const handleErrorSubmission = () => {
        setSubmitBtnClicked(false)
    }

    useEffect(() => {
        if(!isHidden){
            setEmailForm([])
            seperateForm()
        }
    }, [isHidden])

    useEffect(() => {
        setIsShowSummary(false)
        generateConstantValue()
        seperateForm()

        window.addEventListener(Constant.event.renderReport, setReportData)
        window.addEventListener(Constant.event.closeSummary, close)
        window.addEventListener(Constant.event.formSubmit, handleSubmitBtnClick)
        window.addEventListener(Constant.event.errorSubmission, handleErrorSubmission)

        return () => {
            window.removeEventListener(Constant.event.renderReport, setReportData)
            window.removeEventListener(Constant.event.closeSummary, close)
            window.removeEventListener(Constant.event.formSubmit, handleSubmitBtnClick)
            window.removeEventListener(Constant.event.errorSubmission, handleErrorSubmission)
        }
    }, [])

    return <div style={{ display: isHidden ? "none" : "block" }}>
        {isShowSummary ? <SummaryReport data={data} error={errorInput} onClose={closeSummary} /> : null}
        {emailForm.length > 0 && !isShowSummary ? <div className="form-container">
            <p className="bold form-group">{translate('copyOfControlReport')}</p>
            <DynamicFormTemplate isHidden={false} formData={emailForm} defaultValue={state} />
        </div> : null}
        {submitForm.length > 0 && !isShowSummary ? <div className="form-container">
            <h4 className="bold form-group">{translate('record')}</h4>
            <DynamicFormTemplate isHidden={true} formData={submitForm} defaultValue={state} />
            {renderResult()}
            <button type="button" className="form-group" onClick={showSummary}>{translate('previewReport')}</button>
            {!submitBtnClicked ?
                <button className="form-group">{translate('saveReport')}</button>
                : <button className="form-group" disabled><CircularProgress size="1.3rem" /></button>
            }
        </div> : null}
    </div>
}

export default ReportForm;